import { FC } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { StudentProgress } from './types';

interface ProgressTabProps {
  studentProgress: StudentProgress | undefined;
}

export const ProgressTab: FC<ProgressTabProps> = ({ studentProgress }) => {
  return (
    <div className="space-y-4">
      {/* Resumen de Progreso */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card className="bg-white shadow-sm border-[#E6EDF9]">
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-[#2B3674]">
              Lecciones Completadas
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-[#4318FF]">
              {studentProgress?.completed_lessons || 0}/{studentProgress?.total_lessons || 0}
            </div>
            <div className="h-2 bg-[#F4F7FE] rounded-full mt-2 overflow-hidden">
              <div
                className="h-full bg-[#4318FF] rounded-full transition-all duration-500"
                style={{ width: `${((studentProgress?.completed_lessons || 0) / (studentProgress?.total_lessons || 1) * 100)}%` }}
              />
            </div>
          </CardContent>
        </Card>

        <Card className="bg-white shadow-sm border-[#E6EDF9]">
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-[#2B3674]">
              Juegos Explorados
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-[#4318FF]">
              {studentProgress?.games_played || 0}/{studentProgress?.total_games || 0}
            </div>
            <div className="h-2 bg-[#F4F7FE] rounded-full mt-2 overflow-hidden">
              <div
                className="h-full bg-[#4318FF] rounded-full transition-all duration-500"
                style={{ width: `${((studentProgress?.games_played || 0) / (studentProgress?.total_games || 1) * 100)}%` }}
              />
            </div>
          </CardContent>
        </Card>

        <Card className="bg-white shadow-sm border-[#E6EDF9]">
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-[#2B3674]">
              Logros Desbloqueados
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-[#4318FF]">
              {studentProgress?.achievements || 0}
            </div>
            <div className="text-sm text-[#707EAE] mt-2">
              ¡Sigue así!
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Actividad Semanal */}
      <Card className="bg-white shadow-sm border-[#E6EDF9]">
        <CardHeader>
          <CardTitle className="text-[#2B3674]">Actividad Semanal</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-7 gap-2">
            {studentProgress?.weekly_activity.map((day, index) => (
              <div key={index} className="flex flex-col items-center">
                <div className="text-xs text-[#707EAE] mb-1">{day.date}</div>
                <div className="w-full bg-[#F4F7FE] rounded-lg relative" style={{ height: '100px' }}>
                  <div
                    className="absolute bottom-0 w-full bg-[#4318FF] rounded-lg transition-all duration-500"
                    style={{ 
                      height: `${Math.min((day.minutes / 60) * 100, 100)}%`,
                      minHeight: day.minutes > 0 ? '10%' : '0%'
                    }}
                  />
                </div>
                <div className="text-xs text-[#707EAE] mt-1">{day.minutes}min</div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
